import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';

const SiteDataContext = createContext({
  loading: true,
  settings: null,
  slides: [],
  news: [],
  events: [],
  ministries: [],
  investment: [],
  refresh: () => {}
});

export { SiteDataContext };

export const SiteDataProvider = ({ children }) => {
  const [data, setData] = useState({
    loading: true,
    settings: null,
    slides: [],
    news: [],
    events: [],
    ministries: [],
    investment: []
  });

  const load = useCallback(async () => {
    try {
      const [settings, slides, news, events, ministries, investment] = await Promise.all([
        api.get('/settings'),
        api.get('/slides', { params: { active_only: true } }),
        api.get('/news', { params: { published_only: true } }),
        api.get('/events'),
        api.get('/ministries'),
        api.get('/investment-sectors')
      ]);
      setData({
        loading: false,
        settings: settings.data,
        slides: slides.data,
        news: news.data,
        events: events.data,
        ministries: ministries.data,
        investment: investment.data
      });
    } catch (e) {
      console.error('Failed to load site data', e);
      setData((d) => ({ ...d, loading: false }));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SiteDataContext.Provider value={{ ...data, refresh: load }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => useContext(SiteDataContext);
